import React, { ReactElement, useEffect, useState } from "react";
import { Box, Button, Collapse, Stack } from "@chakra-ui/react";
import { FiEye } from "@react-icons/all-files/fi/FiEye";
import { FiEyeOff } from "@react-icons/all-files/fi/FiEyeOff";
import { useLocalStorage } from "react-use";

import { TaskGroup } from "./Task/TaskGroup";

export function LessonTextContent({ children }: { children: ReactElement }) {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  const [shouldShowTextContent, setShouldShowTextContent] = useLocalStorage(
    "showTextContent",
    false
  );

  const showOrHideText = () => {
    setShouldShowTextContent(!shouldShowTextContent);
    window.gtag?.(
      "event",
      `lesson_text_content_clicked_${shouldShowTextContent ? "hide" : "show"}`
    );
  };

  const requiredComponents = ["Task"];

  // Return all tasks
  const filteredTasks = Array.isArray(children)
    ? children?.filter(({ props }) =>
        requiredComponents.includes(props.mdxType)
      )
    : [];

  const taskGroup = filteredTasks.length ? (
    <TaskGroup title="Lesson tasks">{filteredTasks}</TaskGroup>
  ) : null;

  if (!hasMounted) {
    return null;
  }

  return (
    <>
      <Button
        onClick={showOrHideText}
        leftIcon={shouldShowTextContent ? <FiEyeOff /> : <FiEye />}
      >
        {shouldShowTextContent ? "Hide" : "Show"} lesson text content
      </Button>
      <Box fontSize={"xs"} fontStyle={"italic"} opacity={0.7}>
        <p>(Text covers the exact same content as the video)</p>
      </Box>
      <Collapse
        in={shouldShowTextContent}
        unmountOnExit={shouldShowTextContent}
        transition={{ exit: { duration: 0.5 }, enter: { duration: 1 } }}
      >
        <Stack spacing="4">{children}</Stack>
      </Collapse>

      {!shouldShowTextContent && taskGroup && <Box pt="10">{taskGroup}</Box>}
    </>
  );
}
